import { render, staticRenderFns } from "./LeftTabs.vue?vue&type=template&id=520682e2&"
import script from "./LeftTabs.vue?vue&type=script&lang=js&"
export * from "./LeftTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports